export default __webpack_public_path__ + "static/media/profile-avatar.f2d3165c.png";